import React from 'react';
import {
  ClipboardList, Eye, FileOutput, FileText, FileWarning, Lock, Mail, MoreHorizontal, Radar, RefreshCw, StickyNote,
  Trash2, Upload, XCircle,
} from 'lucide-react';
import { Button } from '../ui/button';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger,
} from '../ui/dropdown-menu';

const Accion = ({ icono: Icono, label, onClick, clase, testid, disabled }) => (
  <Button size="sm" variant="outline" onClick={onClick} disabled={disabled} data-testid={testid}
    className={`h-9 gap-1.5 bg-white font-medium transition-colors ${clase}`}>
    <Icono size={15} /> {label}
  </Button>
);

const Item = ({ icono: Icono, label, onClick, testid, clase = '' }) => (
  <DropdownMenuItem onClick={onClick} data-testid={testid} className={`gap-2 ${clase}`}>
    <Icono size={14} /> {label}
  </DropdownMenuItem>
);

// E3: barra de acciones fija del caso (bloquear, vigilar, generar ROS, cerrar, investigar) + acciones secundarias.
export const CasoBarraAcciones = ({ caso, a }) => {
  const vigilado = caso.estado === 'EN_VIGILANCIA';
  const cerrado = caso.estado === 'CERRADO';
  return (
    <div className="sticky top-0 z-30 -mx-6 mb-4 border-y border-slate-200 bg-white/90 px-6 py-2.5 backdrop-blur-md lg:-mx-8 lg:px-8"
      data-testid="caso-barra-acciones">
      <div className="flex flex-wrap items-center gap-2">
        <Accion icono={Lock} label="Bloquear" onClick={a.bloquear} testid="accion-bloquear"
          clase="border-red-300 text-red-700 hover:bg-red-50" />
        {vigilado && caso.vigilancia_manual ? (
          <Accion icono={RefreshCw} label="Revertir vigilancia" onClick={a.revertirVigilancia} testid="revertir-vigilancia-btn"
            clase="border-amber-300 text-amber-700 hover:bg-amber-50" />
        ) : (
          <Accion icono={Eye} label={vigilado ? 'En vigilancia' : 'Vigilar'} onClick={a.vigilar} disabled={vigilado}
            testid="accion-vigilar" clase="border-cyan-300 text-cyan-700 hover:bg-cyan-50" />
        )}
        <Accion icono={FileWarning} label="Generar ROS" onClick={a.generarRos} testid="accion-generar-ros"
          clase="border-purple-300 text-purple-700 hover:bg-purple-50" />
        <Accion icono={XCircle} label={cerrado ? 'Cerrado' : 'Cerrar'} onClick={a.cerrar} disabled={cerrado} testid="accion-cerrar"
          clase="border-slate-300 text-slate-700 hover:bg-slate-50" />
        <Accion icono={Radar} label="Investigar" onClick={a.investigar} testid="accion-investigar"
          clase="border-indigo-300 text-indigo-700 hover:bg-indigo-50" />
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button size="sm" variant="ghost" className="ml-auto h-9 gap-1.5 text-slate-600" data-testid="caso-mas-acciones">
              <MoreHorizontal size={16} /> Más
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-52">
            <Item icono={StickyNote} label="Nota" onClick={a.nota} testid="accion-nota" />
            <Item icono={Upload} label="Documento" onClick={a.documento} testid="accion-documento" />
            <Item icono={ClipboardList} label="Solicitud" onClick={a.solicitud} testid="accion-solicitud" />
            <Item icono={FileOutput} label="Informe" onClick={a.informe} testid="accion-informe" />
            <Item icono={FileText} label="Exportar PDF" onClick={a.exportarPdf} testid="accion-exportar-pdf" />
            <Item icono={Mail} label="Enviar informe por email" onClick={a.enviarEmail} testid="accion-enviar-email" />
            {a.eliminar && (
              <>
                <DropdownMenuSeparator />
                <Item icono={Trash2} label="Eliminar" onClick={a.eliminar} testid="caso-eliminar-btn" clase="text-red-600" />
              </>
            )}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
};

export default CasoBarraAcciones;
